// Browser-rendered image of Telugu text (canvas shapes Telugu correctly; jsPDF fonts cannot).
export async function teluguImage(text, color = "#800020") {
  try { await document.fonts.load('64px "Dhurjati"', text); } catch { /* font may be unavailable offline */ }
  const c = document.createElement("canvas");
  const ctx = c.getContext("2d");
  const font = '64px "Dhurjati", "Noto Sans Telugu", serif';
  ctx.font = font;
  const w = Math.ceil(ctx.measureText(text).width) + 20;
  c.width = w; c.height = 96;
  ctx.font = font; ctx.fillStyle = color; ctx.textBaseline = "middle";
  ctx.fillText(text, 10, 50);
  return { data: c.toDataURL("image/png"), ratio: w / 96 };
}
